import {
  Box,
  Textarea,
  Text,
  VStack,
  HStack,
  IconButton,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { updateWhatsAppAddress } from '../../../hooks/whatsapp_number';

export default function EditAddressPage() {
  const navigate = useNavigate();
  const { orgId, whatsappNumberId } = useParams();
  const toast = useToast();

  const [address, setAddress] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!orgId || !address.trim()) return;

    setSaving(true);
    const res = await updateWhatsAppAddress(
      whatsappNumberId || '',
      orgId,
      address.trim(),
    );
    setSaving(false);

    if (res.success) {
      toast({ title: 'Address updated', status: 'success', duration: 1500 });
      navigate(-1);
    } else {
      toast({
        title: 'Update failed',
        description: 'Unable to update address',
        status: 'error',
        duration: 3000,
      });
    }
  };

  return (
    <Box bg="white" minH="100vh">
      {/* Header */}
      <HStack px={4} py={3} justify="space-between">
        <IconButton
          aria-label="Back"
          icon={<ArrowLeft />}
          variant="ghost"
          onClick={() => navigate(-1)}
        />

        <Text fontWeight="semibold">Address</Text>

        {saving ? (
          <Spinner size="sm" />
        ) : (
          <Text color="#25D366" cursor="pointer" onClick={handleSave}>
            Save
          </Text>
        )}
      </HStack>

      {/* Content */}
      <VStack px={4} mt={4} spacing={2} align="stretch">
        <Textarea
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="Business address"
          resize="none"
          minH="100px"
          autoFocus
        />
        <Text fontSize="xs" color="gray.500">
          This address will appear on your WhatsApp business profile.
        </Text>
      </VStack>
    </Box>
  );
}
